











import {Component, Vue} from "vue-property-decorator";
import BaseLayout from "@/resources/layouts/BaseLayout.vue";

@Component({
    components: {BaseLayout}
})
export default class NotFound extends Vue {
    beforeMount() {
        const route = this.$route.query.route;

        if (route) {
            this.$router.replace(JSON.parse(route as string)).catch(() => {
            });
            return;
        }
    }
}
